import routes from './routes'

/**
 * Gets the routes for a specific type.
 * @param {string} propertyName
 * @returns {String[]}
 */
const getRoutesFor = function(propertyName) {
    let retRoutes = routes
        .filter(br => br.name && br[propertyName])
        .map(r => r.name)

    routes.forEach(br => {
        if (br.children) {
            retRoutes = retRoutes.concat(br.children
                .filter(cr => cr.name && cr[propertyName])
                .map(r => r.name)
            )
        }
    })

    return retRoutes
}

const RouterFilters = {

    /**
     * Gets the static routes.
     * @returns {String[]}
     */
    staticRoutes: function() {
        return getRoutesFor('static')
    },

    /**
     * Gets the routes excluded from 'back' behaviour.
     * @returns {String[]}
     */
    backExcludedRoutes: function() {
        return getRoutesFor('backFlowExclude')
    },

    /**
     * Gets the routes which are invalid for a redirect.
     * @returns {String[]}
     */
    invalidRedirects: function() {
        return getRoutesFor('invalidForRedirect')
            .concat(getRoutesFor('backFlowExclude'))
            .filter(r => r !== 'MyHomeEdit')
    },

    /**
     * Gets the routes which force a user.
     * @returns {String[]}
     */
    userForcingRoutes: function() {
        return getRoutesFor('forcesUser')
    },

    /**
     * Binds the filters.
     * @param {VueRouter|Object} router
     */
    bindFilters(router) {
        // noinspection JSUndefinedPropertyAssignment
        router.staticRoutes = RouterFilters.staticRoutes()
        // noinspection JSUndefinedPropertyAssignment
        router.backExcludedRoutes = RouterFilters.backExcludedRoutes()
        // noinspection JSUndefinedPropertyAssignment
        router.invalidRedirects = RouterFilters.invalidRedirects()
        // noinspection JSUndefinedPropertyAssignment
        router.userForcingRoutes = RouterFilters.userForcingRoutes()
    },
}

/**
 Binds the filters.
 @param {VueRouter|Object} router
 */
export default RouterFilters.bindFilters
